import 'intersection-observer'; // require polyfill for iOS

class {
    onMount() {
        this.polyfillCustomEvent();
    }
    // Needed for IE 9-11
    // Copied from https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#polyfill
    polyfillCustomEvent() {
        if ( typeof window.CustomEvent === 'function' ) return false;
        window.CustomEvent = function CustomEvent ( event, params ) {
            params = params || { bubbles: false, cancelable: false, detail: null };
            var evt = document.createEvent( 'CustomEvent' );
            evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
            return evt;
        };
    }
}
